import React, { Component } from 'react';

class BackButton extends Component {
    static contextTypes = {
      router: () => true,
    }
  
    render() {
      return (
        <button
          className="BackButton"
          onClick={this.context.router.history.goBack}>
          <img src="/favicon/arrow-left-solid.svg" width="15px" alt=""/> Wijzig Club
        </button>
      )
    }
  }

  export default BackButton;


// WEBPACK FOOTER //
// ./src/registration/BackButton.jsx